<template><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
    <g transform="translate(-232 -239.069)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M-6445.285-379.015v-19.4a2.131,2.131,0,0,1,2.146-2.087c2.078-.018,7.613,0,7.613,0a3.913,3.913,0,0,1,3.429,3.948c.007,3.546,0,3.8,0,3.8s.154,2.978-3.933,3.01-2.248,3.042-1.159,4.244,5.5,6.486,5.5,6.486"
              transform="translate(6690.628 648.7)"/>
        <g transform="translate(232 239.069)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <rect width="39" height="39" rx="4"/>
            <rect x="1" y="1" width="37" height="37" rx="3"/>
        </g>
    </g>
</svg>
</template>